<style scoped>
.modal-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 1rem;
    grid-row-gap: 0.5rem;
}
</style>

<template>
    <modal
        ref="RdmGiftModal"
        v-if="show"
        type="confirm"
        :showCancel="true"
        @confirm="rdmGift"
        @cancel="show = false"
        :confirmText="$t('common.confirm')"
        :cancelText="$t('common.back')"
    >
        <div class="modal-wrapper w-full">
            <div style="grid-area: 1 / 1 / 4 / 3;">
                {{ '確定換領禮品？' }}
            </div>
            <div>
                現有積分:
            </div>
            <div class="text-right">
                {{ crdtPntBal | numberWithCommas }}
            </div>
            <div>
                使用積分:
            </div>
            <div class="text-right">
                {{ requiredCrdtPnt | numberWithCommas }}
            </div>
            <div style="grid-area: 7 / 1 / 9 / 1;">
                結餘:
            </div>
            <div style="grid-area: 7 / 2 / 9 / 2;" class="text-right">
                {{ (crdtPntBal - requiredCrdtPnt) | numberWithCommas }}
            </div>
        </div>
        <errorBox :message="errors.server" />
    </modal>
</template>

<script>
import modal from '@/components/modal.vue';
import errorBox from '@/components/errorBox.vue';
import numberWithCommas from '@/components/numberWithCommasFilter.js';

export default {
    components: {
        modal,
        errorBox
    },
    filters: { numberWithCommas },
    props: {
        product: { required: true },
        quantity: { default: 1 }
    },
    data: () => ({
        show: false,
        errors: {}
    }),
    computed: {
        crdtPntBal() {
            return this.$store.state.crdtPntBal;
        },
        requiredCrdtPnt() {
            return this.quantity * this.product.prodUnitCrdtPntQty;
        },
        maxOrdQtyPerPerson() {
            return this.$store.getters.getProductMaxOrdQtyPerPerson(
                this.product
            );
        },
        productActualRemainingQty() {
            return this.$store.getters.productActualRemainingQty(this.product);
        }
    },
    methods: {
        async rdmGift() {
            this.errors = {};
            if (this.crdtPntBal < this.requiredCrdtPnt) {
                this.errors = { server: '您現有的T-coin不足以換取此禮品' };
                return;
            }

            let quantity = this.quantity;
            if (
                quantity + this.productCartQty > this.maxOrdQtyPerPerson ||
                quantity + this.productCartQty > this.productActualRemainingQty
            ) {
                this.errors = { server: '禮品庫存不足' };
                return;
            } else {
                this.$refs['RdmGiftModal'].updateSaveStatus('loading');
                let result = await this.$store.dispatch('redeemGift', {
                    shopListProdKey: this.product.id,
                    prodOrdQty: quantity
                });
                if (result.success) {
                    this.$refs['RdmGiftModal'].updateSaveStatus(undefined);
                    this.$store.dispatch('getCreditPointBalance');
                    this.$store.dispatch('getRdmGiftShopList');
                    this.show = false;
                    this.$emit('success');
                } else {
                    this.$refs['RdmGiftModal'].updateSaveStatus(undefined);
                    this.errors = result.data.errors;
                }
            }
        }
    }
};
</script>
